import * as React from 'react';
import Menu from '@mui/material/Menu';
import { Formik, Form } from 'formik';
import { IconButton, TextField, Typography, Button, Stack, Box } from '@mui/material';
import Iconify from '../Iconify';

const Filter = ({ toggleFilter, applyFilters }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Box style={{ display: 'flex', justifyContent: 'end' }}>
          <IconButton onClick={handleClick}>
            <Iconify icon="ic:round-filter-list" />
            <Typography variant="h6"> Filter</Typography>
          </IconButton>

          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <Formik
              initialValues={{
                userId: '',
                fullname: '',
                phone: '',
                email: '',
                startDate: '',
                endDate: '',
                clubId: '',
                privilegeCardNumber: '',
              }}
              onSubmit={async (values) => {
                applyFilters(values);
              }}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
                <Form style={{ padding: '10px' }}>
                  <Stack direction="column">
                    <Stack direction="row" spacing={1}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        id="userId"
                        fullWidth
                        name="userId"
                        label="User ID"
                        value={values.userId}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="clubId"
                        name="clubId"
                        label="IF Number"
                        value={values.clubId}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction="row" spacing={1}>
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="fullname"
                        name="fullname"
                        label="Fullname"
                        value={values.fullname}
                        onChange={handleChange}
                      />
                      <TextField
                        style={{ paddingBottom: '10px' }}
                        fullWidth
                        id="phone"
                        name="phone"
                        label="Phone"
                        value={values.phone}
                        onChange={handleChange}
                      />
                    </Stack>
                    <Stack direction={'row'} spacing={1}>
                    <TextField
                      style={{ paddingBottom: '10px' }}
                      fullWidth
                      id="email"
                      name="email"
                      type="email"
                      label="Email"
                      value={values.email}
                      onChange={handleChange}
                    />
                    <TextField
                      style={{ paddingBottom: '10px' }}
                      fullWidth
                      id= "privilegeCardNumber"
                      name="privilegeCardNumber"
                      label="Privilege Card Number"
                      value={values.privilegeCardNumber}
                      onChange={handleChange}
                    />
                    </Stack>

                    <Stack direction={'row'} spacing={2}>
                      <TextField
                        type="date"
                        name="startDate"
                        label="Start Date"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        value={values.startDate}
                        onChange={handleChange}
                      />
                      <p style={{ paddingTop: '15px' }}>to</p>
                      <TextField
                        type="date"
                        name="endDate"
                        fullWidth
                        label="End Date"
                        InputLabelProps={{ shrink: true }}
                        value={values.endDate}
                        onChange={handleChange}
                      />
                    </Stack>

                    <Button variant="contained" type="submit" style={{ marginTop: '10px' }}>
                      Filter
                    </Button>
                  </Stack>
                </Form>
              )}
            </Formik>
          </Menu>
        </Box>
      </div>
    </>
  );
};

export default Filter;
